// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1___7c1761b919cf629df16","cls2":"ResearchInterestTags-cls2__af2eb043ec05aa6aa441 ResearchInterestTags-cls1___7c1761b919cf629df16"};